var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_2652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2909 799C25.2001 798.988 16.4851 795.371 10.0569 788.943C3.62877 782.515 0.0120969 773.8 0 764.709L0 573.549C0.0329016 564.462 3.64715 555.755 10.0587 549.316L524.011 35.4553C535.56 23.8981 549.274 14.7299 564.368 8.47476C579.461 2.21958 595.64 -1 611.979 -1C628.317 -1 644.496 2.21958 659.59 8.47476C674.684 14.7299 688.397 23.8981 699.946 35.4553L763.545 99.0536C775.102 110.603 784.27 124.316 790.525 139.41C796.78 154.504 800 170.683 800 187.021C800 203.36 796.78 219.538 790.525 234.632C784.27 249.726 775.102 263.44 763.545 274.989L249.729 788.941C246.547 792.138 242.764 794.673 238.597 796.399C234.43 798.126 229.962 799.009 225.451 799H34.2909ZM68.5819 587.722V730.418H211.232L572.887 368.763L430.237 226.113L68.5819 587.722ZM621.397 320.299L715.172 226.524C725.622 216.043 731.49 201.845 731.49 187.044C731.49 172.243 725.622 158.045 715.172 147.564L651.482 83.8284C641.006 73.3668 626.807 67.4908 612.002 67.4908C597.197 67.4908 582.997 73.3668 572.521 83.8284L478.701 177.648L621.397 320.299Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_2652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.704e976302d1c2ca447a4e132ff0396e.svg";
export { ForwardRef as ReactComponent };